<template>
    <div class="animated fadeIn wrap">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <form @submit="ValidarForm">
                        <header class="card-header">
                            <div class="d-flex">
                                <strong class="align-self-center">Manutenção de conversas da conta</strong>
                            </div>
                        </header>
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <strong>Esta ferramenta irá limpar com base nos filtros abaixo as filas de
                                            conversas!</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <small>Atenção ao utilizar a ferramenta, após a mesma ser executada a rotina de manutenção não poderá ser desfeita!</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-5 col-xl-3">
                                    <label for>Limpar filas:</label>
                                    <b-form-checkbox v-model="filtro.novos" name="check-button" switch>
                                        Novos
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="filtro.andamento" name="check-button" switch>
                                        Andamento
                                    </b-form-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                    <div class="form-group">
                                        <label for>Data de corte</label>
                                        <input v-model="filtro.data" type="datetime-local" class="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div class="row no-print">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button class="btn btn-success mr-2" type="submit">
                                            Executar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div v-if="loading" class="loading-container">
                        <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import RotateSquare from "../../components/RotateSquare";

export default {
    name: "ManutencaoConversa",
    components: { RotateSquare },
    data() {
        return {
            locale: this.$i18n.locale,
            filtro: {
                contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
                novos: false,
                andamento: false,
                data: "",
            },
            loading: false
        };
    },

    computed: {
    },
    watch: {
        locale(val) {
            this.$i18n.locale = val;
        }
    },
    created() { },
    methods: {
        ValidarForm(evt) {
            evt.preventDefault();

            if (this.filtro.novos == false && this.filtro.andamento == false)
                alert("Necessário selecionar pelo menos uma fila para manutenção!")
            else {
                console.log("filtro", this.filtro)
                this.ExecutarManutencao();
            }
        },
        ExecutarManutencao() {
            this.loading = true;
            this.$http({
                url: "/contato/manutencao",
                data: this.filtro,
                method: "POST"
            })
                .then((response) => {
                    this.loading = false;
                    this.$notify({
                        data: ["Manutenção excecutada com sucesso."],
                        type: "success",
                        duration: 10000
                    });
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: ["Ocorreu um erro na manutenção."],
                        type: "warn",
                        duration: 10000
                    });
                });
        }
    }
};
</script>
  